import {Pipe, PipeTransform} from '@angular/core';
import {Entity} from '../classes/entity';
import {IntersectsPipe} from './intersects.pipe';
import LatLngBounds = google.maps.LatLngBounds;

@Pipe({
    name: 'entityInBounds'
})
export class EntityInBoundsPipe implements PipeTransform {
    private readonly intersectsPipe = new IntersectsPipe();

    transform(entity: Entity, latLngBounds: LatLngBounds): boolean {
        return !!entity?.bbox && this.intersectsPipe.transform(latLngBounds, entity.bbox, entity.gnd, entity.line ?? entity.gnd);
    }
}
